import {Box, Button} from '@mui/material';

export default function ButtonBlock({ block }: { block: any }) {
    return (
        <Box sx={{ display: "inline-block" }}>
            <Button
                component="a"
                tabIndex={0} 
                variant={block.variant || "contained"}
                color={block.color || "primary"}
                href={block.url}
                target={block.target || "_blank"}
                rel="noopener noreferrer"
                aria-label={block.text}
                className='tab-indictor'
                sx={{
                    textTransform: "none",
                    backgroundColor: "transparent",
                    fontSize: "clamp(16px, 2vw, 22px)",
                    boxShadow: "none",
                    px: 0,

                    color: "white",

                    "&:hover": {
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        color: "rgb(195, 219, 98)",
                    },
                    "&:focus": {
                        boxShadow: "none",
                    },
                    "&:active": {
                        boxShadow: "none",
                    },
                }}
            >
                {block.text}
            </Button>
        </Box>
    );
}